<template>
    <div class="memwrap modulewrap">
        <Cmember :curnavkv="curnavkv" :navsub.sync="navsub" :options="c_options" @optionsupdate="memopup">
            <Clearn :options="c_myoption" v-if="navsub==1 && isload"></Clearn>
            <Clearnprogress :options="c_myoption" v-if="navsub==2 && isload"></Clearnprogress>
        </Cmember>

    </div>
</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'learns',
        mixins: [mixinmember],
        data() {
            return {
                curnavkv: 103,
                navsub: 1,
                options: {
                    hasoption: 1,
                    hascourse: 1,
                    hastopic: 1,
                    hasdemand: 1,
                    haskw: 1,
                    hasgroup: 1
                }
            };
        },
        components: {
            Clearn: () => import('@/components/Clearn'),
            Clearnprogress: () => import('@/components/Clearnprogress')
        },
        computed: {
            c_myoption: function () {
                let _myoption = this.$common.basic.jsonclone(this.myoption);
                _myoption.tk = 1;
                return _myoption;
            },
            c_options: function () {
                let _options = this.options;
                _options.hastopic = this.navsub == 1 ? 1 : 0;
                _options.anycourse = this.navsub == 1;
                return _options;
            }
        }
    }
</script>
